import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { ThunkDispatch } from "@reduxjs/toolkit";
import JobCard from "../../talent_job/components/JobCard";
import NewsCard from "../../talent_home/components/NewsCard";
import CustomIconButton from "../../../components/CustomIconButton";
import { toFullWidthNumber, formatTimeAgo } from "../../../utils/format";
import { setItemBookmark } from "../../../reducers/talentMypage";
import { ITEM_TYPE } from "../../../constants/index";
import { setCanBackPrevPage } from "reducers/talentHome";

const NewsMarked = ({ items }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

    const handleBookmarkNews = (id: number) => {
        dispatch(setItemBookmark({id: id, view: ITEM_TYPE.NEWS, requestBody: {}}));
    }

    const handleBookmarkJob = (id: number) => {
        dispatch(setItemBookmark({id: id, view: ITEM_TYPE.JOB, requestBody: {}}));
    }

    const goToNewsDetail = (id: number) => {
        dispatch(setCanBackPrevPage(true));
        navigate("/talent/news/" + id);
    }

    return (
        <>
        {items.map((item:any, idx:any) => {
            if (item.item_type == ITEM_TYPE.NEWS) {
                return (
                    <div className="relative w-full md:w-[335px] flex flex-col items-start rounded-2xl bg-white group overflow-hidden alu-section-box-shadow" key={idx}>
                        <NewsCard items={item} goToDetail={(id) => goToNewsDetail(id)} handleBookmark={(id) => handleBookmarkNews(id)} line_option="line-clamp-2" customStyle="!rounded-none" />
                    </div>
                );
            } else {
                return (
                    <div className="w-full md:w-[335px]" key={idx}>
                        <JobCard items={item} handleBookmark={(id) => handleBookmarkJob(id)} />
                    </div>
                );
            }
        })}
        </>
    );
};

export default NewsMarked;
